import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TrackingScripts from "../components/TrackingScripts";
import { buildVersion } from "../services/buildInfo";

import "./thankyou.css"

function Thankyou() {
    const [showSection, setThankYou] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/");
    };

    useEffect(() => {
        const type = localStorage.getItem("type");
        setThankYou(type);
    }, []);

    // Adobe DataLayer (KEPT)
    useEffect(() => {
        window.adobeDataLayer = window.adobeDataLayer || [];
        window.adobeDataLayer.push({
            "event": "pageView",
            "web": {
                "webPageDetails": {
                    "pageViews": {
                        "value": 1
                    },
                    "name": "icicibank:in:en:campaign:accounts:casa:salcorpsavingsaccount:onboarding:eligible thankyou page",
                    "URL": window.location.href,
                    "isErrorPage": "False",
                }
            },
            "_icicibank": {
                "channelInfo": {
                    "version": buildVersion,
                    "name": "nli",
                },
                "pageInfo": {
                    "language": "en",
                    "country": "in",
                    "pageType": "campaign",
                    "virtualPageView": "no vpv",
                    "journey": "na",
                    "subJourney": "na",
                    "subSubJourney": "na",
                },
                "userInfo": {
                    "userType": "na"
                },
                "errorInfo": {
                    "errorType": "na",
                    "errorDetails": "na"
                }
            }
        });
    }, []);


    return (
        <>
            <TrackingScripts />
            <style>{`
                .thankyou_heading {
                    font-family: "Mulish", sans-serif;
                    font-weight: 800;
                    color: #E4792D;
                    text-align: center;
                    font-size: 31px;
                    margin: 20px 0;
                }
                .thank-you h3 {
                    color: #E4792D;
                    font-size: 36px;
                }
                @media screen and (max-width: 1440.5px) {
                    .thankyou_heading {
                        font-size: 25px;
                    }
                    .thank-you h3 {
                        font-size: 26px;
                    }
                }
                @media screen and (max-width: 767.5px) {
                    .thankyou_heading {
                        font-size: 21px;
                    }
                    .thank-you h3 {
                        font-size: 18px;
                    }
                    .thank-you .margin-top.mobile-readable {
                        margin-top: calc(15vh - 10px);
                    }
                    .thankyou_txt.mobile-readable h3 {
                        line-height: 1.4;
                        margin-bottom: 25px;
                    }
                    .thankyou_txt.mobile-readable h3:last-child {
                        margin-bottom: 0;
                    }
                }
            `}</style>
            <section className="thank-you">
                <div className="container">
                    <div className="thank-you">
                        <div className="margin-top mobile-readable" style={{ position: "relative" }}>
                            <h2 className="thankyou_heading">
                                ICICI 3-in-1 Salary Account
                            </h2>
                            <div className="popup-icon">
                                <img src="../dist/img/tick.webp" alt="tick" width="70" height="70" className="img-fluid" />
                            </div>
                            <div className="thankyou_txt mobile-readable">
                                <h3>
                                    Thank you for your interest. Your submission is complete.
                                </h3>
                                <h3>
                                    We are currently reviewing your details to ensure we provide you with the most relevant options for your profile.
                                </h3>
                                <h3>
                                    If applicable, one of our Relationship Managers will contact you shortly to take things forward.
                                </h3>
                            </div>
                            {/* <h3>Our representative will <br />
                                get in touch with you shortly <br />
                                from a number starting with <br /> <span>1600 31 XXXX.</span></h3> */}

                            <button href="/" onClick={handleClick} className="free_back thank_you_back">
                                Go back
                            </button>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}

export default Thankyou;